<div class="gallery-group-container" *ngIf="items?.length > 0">
  <ng-container *ngFor="let item of items || []; index as i">
    <ng-container *ngIf="item.source === 'relevant-people'">
      <relevant-people-item
        #resultItem
        [class.disabled]="item.deleted"
        [class.selected]="innerSelectedIndex === i"
        [class.hovered]="hoveredIndex === i"
        [ngClass]="{ 'preview-mode': isPreviewMode, hovered: hoveredIndex === i }"
        [sessionId]="sessionId"
        [clientSearchId]="clientSearchId"
        [searchId]="searchId"
        [selected]="innerSelectedIndex === i"
        [model]="item"
        tabindex="-1"
        [index]="i"
        [resultsIndex]="item.resultIndex"
        (invoke)="updateSelectedIndex(i); invoke.emit($event, 'result')"
        (click)="updateSelectedIndex(i)"
        [attr.data-index]="i"
        [query]="query"
        [listName]="listName"
        [pageType]="pageType"
        [previewState]="previewState"
        [previewable]="isPreviewClickAction(item.action)"
        (contextOpen)="updateSelectedIndex(i); contextOpen.emit(i, item)"
        (contextClose)="contextClose.emit()"
        (mouseover)="hoveredIndex = i"
        (mouseout)="!onOpenContextMenu ? (hoveredIndex = null) : null"
        class="result-item"
        [viewMode]="previewState === 'side' ? 'small' : item.settings?.viewMode"
      >
      </relevant-people-item>
    </ng-container>
    <ng-container *ngIf="item.source === 'people'">
      <people-view-item
        #resultItem
        [class.disabled]="item.deleted"
        [class.selected]="innerSelectedIndex === i"
        [class.hovered]="hoveredIndex === i"
        [ngClass]="{ 'preview-mode': previewState === 'side', hovered: hoveredIndex === i }"
        [sessionId]="sessionId"
        [clientSearchId]="clientSearchId"
        [searchId]="searchId"
        [selected]="innerSelectedIndex === i"
        [model]="item"
        tabindex="-1"
        [index]="i"
        [resultsIndex]="item.resultIndex"
        (invoke)="updateSelectedIndex(i); invoke.emit($event, 'result')"
        (click)="updateSelectedIndex(i)"
        [attr.data-index]="i"
        [query]="query"
        [listName]="listName"
        [pageType]="pageType"
        [previewState]="previewState"
        [previewable]="previewable"
        (contextOpen)="updateSelectedIndex(i); contextOpen.emit(i, item)"
        (contextClose)="contextClose.emit()"
        (mouseover)="hoveredIndex = i"
        (mouseout)="!onOpenContextMenu ? (hoveredIndex = null) : null"
        class="result-item"
        [viewMode]="previewState === 'side' || !item.settings?.viewMode ? 'line' : item.settings?.viewMode"
      ></people-view-item>
    </ng-container>
    <ng-container *ngIf="isSharepointListAppItem(item)">
      <app-view-item
        #resultItem
        tabindex="-1"
        [index]="i"
        [sessionId]="sessionId"
        [searchId]="searchId"
        [selected]="innerSelectedIndex === i"
        [isLauncher]="isLauncher"
        [model]="item"
        class="result-item"
        (contextOpen)="updateSelectedIndex(i); contextOpen.emit(i, item)"
        (contextClose)="contextClose.emit()"
        (mouseover)="hoveredIndex = i"
        (mouseout)="!onOpenContextMenu ? (hoveredIndex = null) : null"
        (invoke)="updateSelectedIndex(i); invoke.emit($event, 'result')"
        (click)="updateSelectedIndex(i)"
      ></app-view-item>
    </ng-container>
  </ng-container>
</div>
